import React from 'react';

import { Link, Text } from '@chakra-ui/react';
import step1a from 'images/Jira/Step-1a.png';
import step1b from 'images/Jira/Step-1b.png';
import step2 from 'images/Jira/Step-2.png';
import step3 from 'images/Jira/Step-3.png';

export const steps = [
  {
    description: (
      <Text>
        Log in to{' '}
        <Link
          color="primary"
          href="https://id.atlassian.com/manage/api-tokens"
          isExternal
        >
          Atlassian JIRA
        </Link>
        . Now click on the <Text as="b">‘Create Classic API Token’</Text> or
        click on <Text as="b">‘Create API Token’</Text>
        button.
      </Text>
    ),
    image: step1a,
    image2: step1b,
    alt: 'Get Started to Create an API Token',
    alt2: 'Get Started to Create an API Token1',
  },
  {
    description: (
      <Text>
        From the dialog that appears, enter a short, memorable, and easy to
        remember <Text as="b">Label</Text> for your token and click{' '}
        <Text as="b">Create</Text>.
      </Text>
    ),
    image: step2,
    boxSize: '60%',
    alt: 'Create an API Token',
  },
  {
    description: (
      <Text>
        Make sure you copy and save your new API token. You won’t be able to see
        this token again.
      </Text>
    ),
    image: step3,
    boxSize: '60%',
    alt: 'API Token',
  },
];
